import gql from 'graphql-tag';

/**
 * Bản rút gọn của productSearch cho các section trang chủ (BEST_DEALS,
 * NEW_PRODUCTS, MIGHT_FAVORITE...). Chỉ giữ đúng field mà card trang chủ
 * (NewMarketItem/NewDetails/HomeScreenWidget + GA4) thực sự đọc — bỏ
 * description, origin, preservation, supplier.location/imageUrl... giúp
 * payload nhẹ ~70% và server trả nhanh hơn hẳn (đo QA: 1.5s -> ~0.6s với
 * size 100). Nếu card trang chủ cần thêm field mới, nhớ bổ sung vào đây.
 */
export default gql`
  query homeProductSearch(
    $sort: [ProductSort!]!
    $filter: ProductFilter
    $pagination: Pagination!
    $isBoostKamereoProducts: Boolean
  ) {
    productSearch(
      sort: $sort
      filter: $filter
      pagination: $pagination
      isBoostKamereoProducts: $isBoostKamereoProducts
    ) {
      totalResults
      totalPage
      data {
        id
        name
        imageUrl
        note
        supplierInternalCode
        uom
        uomLocal
        vat
        price
        originalPrice
        savingAmount
        inStock
        isFavorite
        tags
        allowAddToCart
        allowPurchase
        private
        tagImageVn
        tagImageEn
        baseUnit
        baseUom
        netUom
        netUnit
        netUomPrice
        baseUomPrice
        priceV2 {
          price
          originalPrice
          vat
          vatIncluded
        }
        category {
          name
          parent {
            name
          }
        }
        supplier {
          id
          name
        }
      }
    }
  }
`;
